import nodataIndex from './index.vue'

const nodata = {
    install(Vue){
        Vue.component('nodata',nodataIndex);
    }
}

export default nodata;